import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TResolveWorkersByNameRequestSchema,
  TResolveWorkersByNameResponseSchema,
} from "./resolveWorkersByName.schema";

export const resolveWorkersByName = (axios: IAxiosInstance) => {
  return async (requestBody: TResolveWorkersByNameRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TResolveWorkersByNameResponseSchema>
    >(`/api/workers/resolve-by-name`, requestBody);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
